import SEO from "@/components/SEO";
import CTABanner from "@/components/CTABanner";
import {
  EquipmentHero, EquipmentFleetGrid, InstrumentsGrid, OwnedFleetMeaning,
} from "@/components/EquipmentSections";

export default function Equipment() {
  return (
    <>
      <SEO
        title="Equipment & Fleet | Yaduraj Enterprises"
        description="Owned fleet: DTH piling rig, JCBs, hydraulic auger, AJAX mixer, transformer oil filtration, tractors and site campers — mobilised on our schedule."
      />
      <EquipmentHero />
      <EquipmentFleetGrid />
      <InstrumentsGrid />
      <OwnedFleetMeaning />
      <CTABanner />
    </>
  );
}
